import { Duration } from 'luxon';

export const formatReadableTimebaseFromSeconds = (seconds: number) => {
  const duration = Duration.fromObject({ seconds: seconds }).shiftTo('hours', 'minutes').toObject();
  const hours = typeof duration.hours && duration.hours > 0? `${duration.hours} hour${duration.hours > 1? 's' : ''}` : '';
  const minutes = typeof duration.minutes && duration.minutes > 0? `${duration.minutes} minute${duration.minutes > 1? 's' : ''}` : '';
  return `${hours} ${minutes}`;
}